import { useState } from 'react';
import { useMemo } from 'react';
import stringToNumArray from '../../../../../../utils/stringManipulation/StringToNumArray';
import { useReducer } from 'react';

export const useGreenToRedCandlesEnabled = (tactic) => {
  const [greenToRedCandlesEnabled, setGreenToRedCandlesEnabled] = useState(
    tactic !== undefined
  );
  return [greenToRedCandlesEnabled, setGreenToRedCandlesEnabled];
};
export const useGreenToRedPositionsEnabled = (useTactic) => {
  const [greenToRedPositionsEnabled, setGreenToRedPositionsEnabled] = useState(
    useTactic !== undefined
  );
  return [greenToRedPositionsEnabled, setGreenToRedPositionsEnabled];
};

export const useLossLimitEnabled = (useTactic) => {
  const [lossLimitEnabled, setLossLimitEnabled] = useState(
    useTactic !== undefined
  );
  return [lossLimitEnabled, setLossLimitEnabled];
};

export const usePreserveProfitEnabled = (tactic) => {
  const [preserveProfitEnabled, setPreserveProfitEnabled] = useState(
    tactic !== undefined
  );
  return [preserveProfitEnabled, setPreserveProfitEnabled];
};

export const usePositionPriceTrailEnabled = (tactic) => {
  const [positionPriceTrailEnabled, setPositionPriceTrailEnabled] = useState(
    tactic !== undefined
  );
  return [positionPriceTrailEnabled, setPositionPriceTrailEnabled];
};

export const useUnderlyingPriceTrailEnabled = (tactic) => {
  const [underlyingPriceTrailEnabled, setUnderlyingPriceTrailEnabled] =
    useState(tactic !== undefined);
  return [underlyingPriceTrailEnabled, setUnderlyingPriceTrailEnabled];
};

export const useCandleTrailEnabled = (tactic) => {
  const [candleTrailEnabled, setCandleTrailEnabled] = useState(
    tactic !== undefined
  );
  return [candleTrailEnabled, setCandleTrailEnabled];
};

export const useGrabCentsEnabled = (tactic) => {
  const [grabCentsEnabled, setGrabCentsEnabled] = useState(
    tactic !== undefined
  );
  return [grabCentsEnabled, setGrabCentsEnabled];
};

export const useRatchetBracketEnabled = (tactic) => {
  const [ratchetBracketEnabled, setRatchetBracketEnabled] = useState(
    tactic !== undefined
  );
  return [ratchetBracketEnabled, setRatchetBracketEnabled];
};

export const useBreakPriceEnabled = (tactic) => {
  const [breakPriceEnabled, setBreakPriceEnabled] = useState(
    tactic !== undefined
  );
  return [breakPriceEnabled, setBreakPriceEnabled];
};

export const usePositionBreakPriceEnabled = (tactic) => {
  const [positionBreakPriceEnabled, setPositionBreakPriceEnabled] = useState(
    tactic !== undefined
  );
  return [positionBreakPriceEnabled, setPositionBreakPriceEnabled];
};

export const useCandleMagnitudeEnabled = (tactic) => {
  const [candleMagnitudeEnabled, setCandleMagnitudeEnabled] = useState(
    tactic !== undefined
  );
  return [candleMagnitudeEnabled, setCandleMagnitudeEnabled];
};

export const useAtrTrailEnabled = (tactic) => {
  const [atrTrailEnabled, setAtrTailEnabled] = useState(tactic !== undefined);
  return [atrTrailEnabled, setAtrTailEnabled];
};

export const useUnderlyingPriceExitEnabled = (tactic) => {
  const [underlyingPriceExitEnabled, setUnderlyingPriceExitEnabled] = useState(
    tactic !== undefined
  );
  return [underlyingPriceExitEnabled, setUnderlyingPriceExitEnabled];
};

export const useMfeRetracementEnabled = (tactic) => {
  const [mfeRetracementEnabled, setMfeRetracementEnabled] = useState(
    tactic !== undefined
  );
  return [mfeRetracementEnabled, setMfeRetracementEnabled];
};

export const useGrabCentsMode = (mode) => {
  const [grabCentsMode, setGrabCentsMode] = useState(
    mode !== undefined ? mode : 'quantity'
  );
  return [grabCentsMode, setGrabCentsMode];
};

export const useMfeRetracement = () => {
  const [mfeRetracement, dispatchMfeRetracement] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      mfeType: 'byPositionPrice', //drop down options: byPositionPrice, byPnl
      retraceType: 'expanding', //dont show to users, this is for future implementations
      activateSetting: 'PERCENT', //options: PERCENT, AMOUNT. notes: If mfeType === position price, this must be a percentage. if mfeType==byPnl, this can be either pct or amount
      pnlType: 'OVERALL', //options: OVERALL, UNREALIZED. notes: only selectable if mfeType===byPnl
      retracePct: 0, //pct to retrace from max mfe
      activationValue: 0,
    }
  );
  return [mfeRetracement, dispatchMfeRetracement];
};

export const useUnderlyingPriceExit = () => {
  const [underlyingPriceExit, dispatchUnderlyingPriceExit] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      underlyingPricePairs: [], //[{price: 101, qtyPct: .25}, {price: 102, qtyPct: .25},{price: 103, qtyPct: .25},]
    }
  );
  return [underlyingPriceExit, dispatchUnderlyingPriceExit];
};

export const useLossLimit = (startingValue) => {
  const [lossLimit, dispatchLossLimit] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      amount: startingValue !== undefined ? startingValue : 0,
      lossLimitMode: startingValue !== undefined ? startingValue : 'AMOUNT',
    }
  );
  return [lossLimit, dispatchLossLimit];
};

export const usePreserveProfit = (startingValue) => {
  const [preserveProfit, dispatchPreserveProfit] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      amount: startingValue !== undefined ? startingValue : 0,
      activationProfitAmount: startingValue !== undefined ? startingValue : 0,
    }
  );
  return [preserveProfit, dispatchPreserveProfit];
};

export const usePositionPriceTrail = (startingValue) => {
  const [positionPriceTrail, dispatchPositionPriceTrail] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      amount: startingValue !== undefined ? startingValue : 0,
    }
  );
  return [positionPriceTrail, dispatchPositionPriceTrail];
};

export const useUnderlyingPriceTrail = (startingValue) => {
  const [underlyingPriceTrail, dispatchUnderlyingPriceTrail] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      amount: startingValue !== undefined ? startingValue : 0,
    }
  );
  return [underlyingPriceTrail, dispatchUnderlyingPriceTrail];
};

export const useCandleTrail = (
  candleDuration,
  usePrePostMarketData,
  timeUnit
) => {
  const [candleTrail, dispatchCandleTrail] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      candleDuration: candleDuration !== undefined ? candleDuration : 1,
      usePrePostMarketData:
        usePrePostMarketData !== undefined ? usePrePostMarketData : false,
      breakBy: 0.0,
      timeUnit: timeUnit !== undefined ? timeUnit : 'MINUTES',
    }
  );
  return [candleTrail, dispatchCandleTrail];
};

export const useGreenToRedCandles = (
  candleDuration,
  inRightDirectionPct,
  retracePct,
  minCandleHeight,
  timeUnit
) => {
  const [greenToRedCandles, dispatchGreenToRedCandles] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      candleDuration: candleDuration !== undefined ? candleDuration : 1,
      inRightDirectionPct:
        inRightDirectionPct !== undefined ? inRightDirectionPct : 0,
      retracePct: retracePct !== undefined ? retracePct : 0.4,
      minCandleHeight: minCandleHeight !== undefined ? minCandleHeight : 0.5,
      timeUnit: timeUnit !== undefined ? timeUnit : 'MINUTES',
    }
  );
  return [greenToRedCandles, dispatchGreenToRedCandles];
};

export const useGreenToRedPositions = (
  inRightDirectionPct,
  retracePct,
  pnlTracking
) => {
  const [greenToRedPositions, dispatchGreenToRedPositions] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      inRightDirectionPct:
        inRightDirectionPct !== undefined ? inRightDirectionPct : 0,
      retracePct: retracePct !== undefined ? retracePct : 0,
      pnlTracking: pnlTracking !== undefined ? pnlTracking : 'unrealized',
    }
  );
  return [greenToRedPositions, dispatchGreenToRedPositions];
};

export const useGrabCents = (
  quantityPerLevel,
  percentagePerLevel,
  trailQuantity,
  trailPercent,
  centsPerLevel,
  trailAmount
) => {
  const [grabCents, dispatchGrabCents] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      quantityPerLevel: quantityPerLevel !== undefined ? quantityPerLevel : [],
      percentagePerLevel:
        percentagePerLevel !== undefined ? percentagePerLevel : [],

      trailQuantity: trailQuantity !== undefined ? trailQuantity : 0,
      trailPercent: trailPercent !== undefined ? trailPercent : 0,

      centsPerLevel: centsPerLevel !== undefined ? centsPerLevel : [],
      trailAmount: trailAmount !== undefined ? trailAmount : 0,
      takeProfitMode: 'DOLLARS',
    }
  );
  return [grabCents, dispatchGrabCents];
};

export const useRatchetBracket = () => {
  const [ratchetBracket, dispatchRacketBracket] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      mode: 'EQUAL_INTERVAL',
      targetPerBracket: 0.1,
      stopPerBracket: 0.1,
      qtyBasisValuePerBracket: 0,
      qtyBasis: 'PERCENT',
      trailQtyBasisValue: 0,
      trailAmount: 0,
    }
  );
  return [ratchetBracket, dispatchRacketBracket];
};

export const useBreakPrice = (prices) => {
  const [breakPrice, dispatchBreakPrice] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      prices: prices !== undefined ? prices : [],
    }
  );
  return [breakPrice, dispatchBreakPrice];
};

export const usePositionBreakPrice = (prices) => {
  const [breakPrice, dispatchBreakPrice] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      prices: prices !== undefined ? prices : [],
    }
  );
  return [breakPrice, dispatchBreakPrice];
};

export const useAtrTrail = () => {
  const [atrTrail, dispatchAtrTrail] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      pctOfAtr: 1, //default is 1 whole ATR
      ATR: {
        candlesBack: 14, //field # of candles
        atrType: 'WILDER', //options: SMA, WILDER, SMA_NO_GAP. drop down. wilder used 90% of time
        candleDuration: 1, //do candle duration + time unit combo
        timeUnit: 'MINUTES',
      },
    }
  );
  return [atrTrail, dispatchAtrTrail];
};
export const useCandleMagnitude = () => {
  const [candleMagnitude, dispatchCandleMagnitude] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      candleDuration: 1,
      numberOfPivots: 0,
      qtyPctPerPivot: [],
      exitInPivotCandle: 'high_low', // high_low or mid
      usePivotsAsTrails: false,
      filterInsideCandleMagnitudes: false,
      timeUnit: 'MINUTES', // MINUTES, HOURS, DAYS, WEEKS, MONTHS, QUARTERS, YEARS
      useAtr: false,
      ATR: {
        candlesBack: 14, //field # of candles
        atrType: 'WILDER', //options: SMA, WILDER, SMA_NO_GAP. drop down. wilder used 90% of time
        candleDuration: 1, //do candle duration + time unit combo
        timeUnit: 'MINUTES',
      },
      filterFirstMagnitudeBasedOnAtr: false, //think of this section like the repeating design. checkbox "a"
      pctOfAtrForFilter: 0.0, //field "a" as % of atr
      filterAllMagnitudeBasedOnAtr: false,
      pctOfAtrForFilterAllMag: 0,
      useAtrInsteadOfMag: false,
      pctAtrInsteadOfMag: 0,
      generateFromAtrWhenNoPivots: false,
      pctAtrGenerateAtrWhenNoPivots: 1,

      initialStop: 'NONE', //NONE, ATR,CANDLE_RETRACE,CANDLE_HIGH_LOW
      pctAtrInitialStop: 0,
      pctRetraceInitialStop: 0,

      firstTargetStop: 'NONE', //NONE,ATR,CANDLE_RETRACE,CANDLE_HIGH_LOW,BREAK_EVEN
      pctAtrFirstTargetStop: 0,
      pctRetraceFirstTargetStop: 0,
    }
  );
  return [candleMagnitude, dispatchCandleMagnitude];
};

export const useGrabCentsDetails = (grab_cents, grab_cents_mode) => {
  const [grabCents, dispatchGrabCents] = grab_cents;
  const [grabCentsMode, setGrabCentsMode] = grab_cents_mode;
  const grabCentsDetails = useMemo(
    () => ({
      ...(grabCentsMode === 'percentage' && {
        percentagePerLevel: grabCents.percentagePerLevel,
        centsPerLevel: stringToNumArray(grabCents.centsPerLevel),
        trailPercent: grabCents.trailPercent,
        trailAmount: grabCents.trailAmount,
        takeProfitMode: grabCents.takeProfitMode
          ? grabCents.takeProfitMode
          : 'DOLLARS', //DOLLARS, PERCENT
      }),
      ...(grabCentsMode === 'quantity' && {
        quantityPerLevel: stringToNumArray(grabCents.quantityPerLevel),
        centsPerLevel: stringToNumArray(grabCents.centsPerLevel),
        trailQuantity: grabCents.trailQuantity,
        trailAmount: grabCents.trailAmount,
        takeProfitMode: grabCents.takeProfitMode
          ? grabCents.takeProfitMode
          : 'DOLLARS', //DOLLARS, PERCENT
      }),
    }),
    [grabCentsMode, grabCents]
  );
  return grabCentsDetails;
};

export const useExitTactics = (
  loss_limit_enabled,
  loss_limit,
  preserve_profit_enabled,
  preserve_profit,
  position_price_trail_enabled,
  position_price_trail,
  underlying_price_trail_enabled,
  underlying_price_trail,
  grab_cents_enabled,
  grab_cents,
  grab_cents_details,
  ratchet_bracket_enabled,
  ratchet_bracket,
  candle_trail_enabled,
  candle_trail,
  gToRCandlesEnabled,
  gToRPositionsEnabled,
  gToRCandles,
  gToRPositions,
  break_price_enabled,
  break_price,
  position_break_price_enabled,
  position_break_price,
  candle_magnitude_enabled,
  candle_magnitude,
  atr_trail_enabled,
  atr_trail,
  mfe_RetracementEnabled,
  mfe_retracement,
  underlying_price_exit_enabled,
  underlying_price_exit
) => {
  const [lossLimitEnabled, setLossLimitEnabled] = loss_limit_enabled;
  const [lossLimit, dispatchLossLimit] = loss_limit;

  const [preserveProfitEnabled, setPreserveProfitEnabled] =
    preserve_profit_enabled;
  const [preserveProfit, dispatchPreserveProfit] = preserve_profit;

  const [positionPriceTrailEnabled, setPositionPriceTrailEnabled] =
    position_price_trail_enabled;
  const [positionPriceTrail, dispatchPositionPriceTrail] = position_price_trail;

  const [underlyingPriceTrailEnabled, setUnderlyingPriceTrailEnabled] =
    underlying_price_trail_enabled;
  const [underlyingPriceTrail, dispatchUnderlyingPriceTrail] =
    underlying_price_trail;

  const [grabCentsEnabled, setGrabCentsEnabled] = grab_cents_enabled;
  const [grabCents, dispatchGrabCents] = grab_cents;
  const grabCentsDetails = grab_cents_details;

  const [ratchetBracketEnabled, setRatchetBracketEnabled] =
    ratchet_bracket_enabled;
  const [ratchetBracket, dispatchRacketBracket] = ratchet_bracket;

  const [candleTrailEnabled, setCandleTrailEnabled] = candle_trail_enabled;
  const [candleTrail, dispatchCandleTrail] = candle_trail;

  const [greenToRedCandlesEnabled, setGreenToRedCandlesEnabled] =
    gToRCandlesEnabled;
  const [greenToRedCandles, dispatchGreenToRedCandles] = gToRCandles;

  const [greenToRedPositionsEnabled, setGreenToRedPositionsEnabled] =
    gToRPositionsEnabled;
  const [greenToRedPositions, dispatchGreenToRedPositions] = gToRPositions;

  const [breakPriceEnabled, setBreakPriceEnabled] = break_price_enabled;
  const [breakPrice, dispatchBreakPrice] = break_price;

  const [positionBreakPriceEnabled, setPositionBreakPriceEnabled] =
    position_break_price_enabled;
  const [positionBreakPrice, dispatchPositionBreakPrice] = position_break_price;

  const [candleMagnitudeEnabled, setCandleMagnitudeEnabled] =
    candle_magnitude_enabled;
  const [candleMagnitude, dispatchCandleMagnitude] = candle_magnitude;

  const [atrTrailEnabled, setAtrTrailEnabled] = atr_trail_enabled;
  const [atrTrail, dispatchAtrTail] = atr_trail;

  const [mfeRetracementEnabled, setMfeRetracementEnabled] =
    mfe_RetracementEnabled;
  const [mfeRetracement, dispatchMfeRetracement] = mfe_retracement;

  const [underlyingPriceExitEnabled, setUnderlyingPriceExitEnabled] =
    underlying_price_exit_enabled;

  const [underlyingPriceExit, dispatchUnderlyingPriceExit] =
    underlying_price_exit;

  const exitTactics = useMemo(
    () => ({
      ...(lossLimitEnabled && { LOSS_LIMIT: lossLimit }),
      ...(preserveProfitEnabled && { PRESERVE_PROFIT: preserveProfit }),
      ...(positionPriceTrailEnabled && {
        POSITION_PRICE_TRAIL: positionPriceTrail,
      }),
      ...(underlyingPriceTrailEnabled && {
        UNDERLYING_PRICE_TRAIL: underlyingPriceTrail,
      }),
      ...(candleTrailEnabled && { CANDLE_TRAIL: candleTrail }),
      ...(grabCentsEnabled && { GRAB_CENTS: grabCentsDetails }),
      ...(ratchetBracketEnabled && { RATCHET_BRACKET: ratchetBracket }),
      ...(greenToRedCandlesEnabled && {
        GREEN_TO_RED_CANDLES: greenToRedCandles,
      }),
      ...(greenToRedPositionsEnabled && {
        GREEN_TO_RED_POSITIONS: greenToRedPositions,
      }),
      ...(breakPriceEnabled && { BREAK_PRICE: breakPrice }),
      ...(positionBreakPriceEnabled && {
        POSITION_BREAK_PRICE: positionBreakPrice,
      }),
      ...(candleMagnitudeEnabled && { CANDLE_MAGNITUDE: candleMagnitude }),
      ...(atrTrailEnabled && { ATR_TRAIL: atrTrail }),
      ...(mfeRetracementEnabled && { MFE_RETRACEMENT: mfeRetracement }),
      ...(underlyingPriceExitEnabled && {
        UNDERLYING_PRICE_EXIT: underlyingPriceExit,
      }),
    }),
    [
      lossLimitEnabled,
      lossLimit,
      preserveProfitEnabled,
      preserveProfit,
      positionPriceTrailEnabled,
      positionPriceTrail,
      underlyingPriceTrailEnabled,
      underlyingPriceTrail,
      candleTrailEnabled,
      candleTrail,
      grabCentsEnabled,
      grabCentsDetails,
      ratchetBracketEnabled,
      ratchetBracket,
      greenToRedCandlesEnabled,
      greenToRedCandles,
      greenToRedPositionsEnabled,
      greenToRedPositions,
      breakPriceEnabled,
      breakPrice,
      positionBreakPriceEnabled,
      positionBreakPrice,
      candleMagnitudeEnabled,
      candleMagnitude,
      atrTrailEnabled,
      atrTrail,
      mfeRetracementEnabled,
      mfeRetracement,
      underlyingPriceExitEnabled,
      underlyingPriceExit,
    ]
  );
  return exitTactics;
};
